import React from 'react';
import ReactDOM from 'react-dom';
import Loader from './Loader.jsx';

const element = document.createElement('div');
element.style.height = '100vh';
element.style.width = '100vw';
element.style.position = 'fixed';
element.style.top = '0';
element.style.zIndex = '9999';
element.style.display = 'none';
element.id = 'LoadingIndicator';
document.body.appendChild(element);

ReactDOM.render(
  <Loader isLoading={true} />,
  document.getElementById('LoadingIndicator')
);

const LoadingIndicator = {
  isLoading: false,
  showIndicator() {
    if (this.isLoading) {
      return (element.style.display = 'block');
    }
  },
  show() {
    this.isLoading = true;
    setTimeout(this.showIndicator.bind(this), 300);
  },
  hide() {
    this.isLoading = false;
    return (element.style.display = 'none');
  },
  resolve(promise) {
    this.show();
    return new Promise((resolve, reject) => {
      promise
        .then(resolve)
        .then(() => this.hide())
        .catch((...args) => {
          this.hide();
          reject(...args);
        });
    });
  },
};

export default LoadingIndicator;
